function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "New logo");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  id: "_Compound_Path_",
  "data-name": "<Compound Path>",
  className: "cls-1",
  d: "M63.81,11.56A3.16,3.16,0,1,1,67,8.4,3.16,3.16,0,0,1,63.81,11.56ZM63.81,0a8.41,8.41,0,1,0,8.4,8.4A8.41,8.41,0,0,0,63.81,0Z",
  transform: "translate(-0.13)"
}), React.createElement("path", {
  id: "_Path_",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M53.4,5.78H48.46A.42.42,0,0,1,48,5.36V.42A.42.42,0,0,0,47.62,0H43.2a.41.41,0,0,0-.41.42V5.36a.43.43,0,0,1-.43.42H37.43A.42.42,0,0,0,37,6.2v4.41a.42.42,0,0,0,.42.42h4.93a.43.43,0,0,1,.43.42v4.94a.41.41,0,0,0,.41.42h4.42a.42.42,0,0,0,.42-.42V11.45a.42.42,0,0,1,.42-.42H53.4a.42.42,0,0,0,.42-.42V6.2a.42.42,0,0,0-.42-.42",
  transform: "translate(-0.13)"
}), React.createElement("path", {
  id: "_Compound_Path_2",
  "data-name": "<Compound Path>",
  className: "cls-3",
  d: "M27,11.56A3.16,3.16,0,1,1,30.17,8.4,3.16,3.16,0,0,1,27,11.56ZM27,0a8.41,8.41,0,1,0,8.41,8.4A8.41,8.41,0,0,0,27,0Z",
  transform: "translate(-0.13)"
}), React.createElement("path", {
  id: "_Path_2",
  "data-name": "<Path>",
  className: "cls-4",
  d: "M16.93.42A.42.42,0,0,0,16.51,0H12.1a.42.42,0,0,0-.42.42v8h0a3.15,3.15,0,0,1-6.28.39h0A.43.43,0,0,0,5,8.4H.55a.42.42,0,0,0-.42.42h0v0a8.41,8.41,0,0,0,16.8-.47v-8Z",
  transform: "translate(-0.13)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 72.08 16.81"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/logo.f776403c.svg";
export { SvgComponent as ReactComponent };